'use es6';

import { memo } from 'react';
import { DEFAULT_DEBUG } from '../../constants/debug';
import { FUNNEL } from '../../constants/visualizationTypes';
import { FunnelVisualization } from './funnelRecords';
import { BuildColumnFunnelVisualization } from './ColumnFunnel';
import { Funnel } from './OldFunnelComponent';
import { jsx as _jsx } from "react/jsx-runtime";
export { getHighchartsOptions } from './ColumnFunnel';
export const type = FUNNEL;
export const record = FunnelVisualization;
const FunnelViz = ({
  visualization,
  debug = DEFAULT_DEBUG,
  onReportVisualize
}) => {
  const FunnelComponent = visualization.get('horizontalFunnel') ? BuildColumnFunnelVisualization(visualization, debug, onReportVisualize) : /*#__PURE__*/_jsx(Funnel, {
    visualization: visualization
  });
  return FunnelComponent;
};
export const Render = /*#__PURE__*/memo(FunnelViz);